import { Translations } from './types';

export const it: Translations = {
  sidebar: {
    welcome: 'Benvenuto,',
    logout: 'Logout',
    closeMenu: 'Chiudi menu',
    openMenu: 'Apri menu',
    menuItems: {
      'Homepage': 'Homepage',
      'Bacheca': 'Bacheca',
      'Eventi': 'Eventi',
      'Pubblicità': 'Pubblicità',
      'Invia Messaggi': 'Invia Messaggi',
      'Clienti': 'Clienti',
      'Matching': 'Matching',
      'Location': 'Location',
      'Team': 'Team',
      'Contabilità': 'Contabilità',
      'Agenzia Amore': 'Agenzia Amore',
      'Dating Coach': 'Dating Coach',
      'Consulente d\'Immagine': 'Consulente d\'Immagine',
      'Messaggeria': 'Messaggeria',
      'Tavoli': 'Tavoli',
      'Messaggi': 'Messaggi',
      'Consulenze': 'Consulenze',
      'Corsi per Single': 'Corsi per Single',
      'Viaggi per Single': 'Viaggi per Single',
      'Marketing': 'Marketing',
      'Altri Eventi': 'Altri Eventi',
      'Speed Date': 'Speed Date',
      'Gestione Staff': 'Gestione Staff',
    },
  },
  profile: {
    tabs: {
      profile: 'Profilo',
      settings: 'Impostazioni',
      company: 'Azienda',
    },
    header: {
      name: 'Nome',
      role: 'Ruolo',
      city: 'Città',
      notDefined: 'Non definita',
    },
    roles: {
      admin: 'Amministratore',
      organizer: 'Organizzatore',
      pr: 'PR',
      collaboratore: 'Collaboratore',
    },
    form: {
      name: 'Nome',
      email: 'Email',
      phone: 'Numero di Telefono',
      city: 'Città',
      emailReadonly: 'L\'email non può essere modificata',
      phonePlaceholder: '+39 123 456 7890',
      cityPlaceholder: 'Inserisci città',
      changePassword: 'Cambia Password',
      newPassword: 'Nuova Password',
      confirmPassword: 'Conferma Nuova Password',
      newPasswordPlaceholder: 'Lascia vuoto per non modificare',
      confirmPasswordPlaceholder: 'Ripeti la nuova password',
      saving: 'Salvataggio...',
      save: 'Salva Modifiche',
    },
    settings: {
      notifications: 'Notifiche',
      emailNotifications: 'Email Notifiche',
      pushNotifications: 'Notifiche Push',
      eventReminders: 'Promemoria Eventi',
      security: 'Sicurezza',
      twoFactor: 'Autenticazione a Due Fattori',
      language: 'Lingua',
      languageDescription: 'Seleziona la lingua dell\'interfaccia di amministrazione',
    },
    company: {
      title: 'Profilo Aziendale',
      companyName: 'Nome Azienda',
      email: 'Email',
      phone: 'Telefono',
    },
    messages: {
      passwordMismatch: 'Le password non coincidono',
      passwordTooShort: 'La password deve essere di almeno 6 caratteri',
      updateSuccess: 'Profilo aggiornato con successo',
      updateError: 'Errore durante l\'aggiornamento del profilo',
    },
  },
  homepage: {
    title: 'Homepage',
    loading: 'Caricamento...',
    stats: {
      totalEvents: 'Eventi Totali',
      participants: 'Partecipanti',
      locations: 'Location',
      matches: 'Match',
      totalClients: 'Clienti Totali',
      totalRevenue: 'Entrate Totali',
      showRevenue: 'Mostra entrate',
      hideRevenue: 'Nascondi entrate',
    },
    recentEvents: 'STATISTICHE ULTIMI EVENTI',
    upcomingEvents: 'PROSSIMI EVENTI ITALIA',
    table: {
      eventName: 'Nome Evento',
      ageRange: 'Fascia d\'Età',
      date: 'Data',
      location: 'Location',
      city: 'Città',
      participants: 'Partecipanti',
      matches: 'Match',
      menRevenue: 'Entrate Uomini',
      womenRevenue: 'Entrate Donne',
      total: 'Totale',
      men: 'U: ',
      women: 'D: ',
    },
    noEvents: 'Nessun evento programmato',
    eventStatus: {
      soldOut: 'SOLD-OUT + LISTA ATTESA',
      almostFull: 'QUASI COMPLETO',
      limitedSpots: 'POSTI LIMITATI',
      scheduled: 'IN PROGRAMMA',
    },
  },
  login: {
    brand: 'FlashCrush',
    email: 'Email',
    password: 'Password',
    loggingIn: 'Accesso in corso...',
    logIn: 'Accedi',
    register: 'Registrati',
    forgotPassword: 'Password dimenticata?',
    registrationTitle: 'Registrazione',
    registrationDescription: 'Crea un nuovo account per partecipare agli eventi.',
    fullName: 'Nome Completo',
    registering: 'Registrazione in corso...',
    alreadyHaveAccount: 'Hai già un account? Accedi',
    resetPasswordTitle: 'Recupero Password',
    resetPasswordDescription: 'Inserisci la tua email per ricevere le istruzioni per il recupero della password.',
    sending: 'Invio in corso...',
    sendInstructions: 'Invia istruzioni',
    backToLogin: 'Torna al login',
    resetEmailSent: 'Se l\'indirizzo email esiste, riceverai le istruzioni per reimpostare la password.',
    errors: {
      invalidCredentials: 'Credenziali non valide. Verifica email e password e riprova.',
      emailNotConfirmed: 'Email non confermata. Controlla la tua casella email per il link di conferma.',
      invalidEmailFormat: 'Formato email non valido. Inserisci un indirizzo email valido.',
      genericLoginError: 'Si è verificato un errore durante l\'accesso. Riprova più tardi.',
      registrationError: 'Errore durante la registrazione',
      resetPasswordError: 'Errore durante il recupero della password',
    },
  },
  auth: {
    pendingApproval: 'Il tuo account è in attesa di approvazione da parte di un amministratore.',
    accountRejected: 'Il tuo account è stato rifiutato. Contatta l\'amministratore per maggiori informazioni.',
    accountSuspended: 'Il tuo account è stato sospeso. Contatta l\'amministratore per maggiori informazioni.',
    registrationComplete: 'Registrazione completata! Il tuo account è in attesa di approvazione da parte di un amministratore. Riceverai una notifica quando potrai accedere.',
  },
  common: {
    loading: 'Caricamento...',
    error: 'Errore',
    close: 'Chiudi',
    cancel: 'Annulla',
    confirm: 'Conferma',
    save: 'Salva',
    delete: 'Elimina',
    edit: 'Modifica',
    add: 'Aggiungi',
    search: 'Cerca',
    noResults: 'Nessun risultato',
    back: 'Indietro',
    next: 'Avanti',
    hiddenAmount: '••••• €',
  },
};
